import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import Icon from './Icon';
import Translate from './Translate';
import { CheckboxProps } from '../models/components/Checkbox';
import { action, computed, observable } from 'mobx';
import VisuallyHiddenWrapper from './VisuallyHiddenWrapper';

const CheckboxWrapper = styled<any, any>('div', 'checkboxWrapper', 'checkbox')`
    ${propStyles};
    opacity: ${props => (props.disabled ? 0.5 : 1)};
    cursor: pointer;
`;

CheckboxWrapper.defaultProps = {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: '0 0 auto',
    paddingY: 'xs',
    color: 'body',
    hover: {
        color: 'primary',
    },
    selected: {
        color: 'primary',
    },
    alternated: {
        color: 'gray500',
    },
};

const Input = styled<any, any>('input', 'input', 'checkbox')`
    ${propStyles};
`;

const Label = styled<any, any>('label', 'label', 'checkbox')`
    ${propStyles};
`;

Label.defaultProps = {
    display: 'inherit',
};

@observer
class Checkbox extends Component<CheckboxProps> {
    @observable.ref inputHasFocus: boolean = false;

    constructor(props) {
        super(props);
        this.onInputBlur = this.onInputBlur.bind(this);
        this.onInputFocus = this.onInputFocus.bind(this);
    }

    @computed
    get labelFocusStyles() {
        const { theme } = this.props;
        if (this.inputHasFocus && theme.Input && theme.Input.focus) {
            return theme.Input.focus;
        }
        return {};
    }

    /**
     * We tried to utilize styled components to apply the focus styles
     * to the label when the checkbox is hidden, but were not getting it
     * right. Thus we went with this approach of having the on Focus and
     * Blur events to apply the focus styles on the styled checkboxes
     * to the user is the checkbox
     */
    @action
    onInputFocus() {
        this.inputHasFocus = true;
    }

    @action
    onInputBlur() {
        this.inputHasFocus = false;
    }

    render() {
        const {
            theme,
            label,
            showLabel,
            ariaLabel,
            checked,
            disabled,
            active,
            onChange,
            checkedIconFileName = 'CheckboxMarkedIcon',
            uncheckedIconFileName = 'CheckboxIcon',
            children,
            metricContext,
        } = this.props;

        return (
            <CheckboxWrapper
                disabled={disabled}
                data-selected={checked}
                data-alternated={!active}
                {...theme.CheckboxLabel}
            >
                <Label htmlFor={metricContext} {...this.labelFocusStyles}>
                    <VisuallyHiddenWrapper>
                        <Input
                            id={metricContext}
                            type="checkbox"
                            checked={checked}
                            onChange={onChange}
                            onFocus={this.onInputFocus}
                            onBlur={this.onInputBlur}
                            disabled={disabled}
                            data-metric-id={`checkbox-${metricContext}`}
                            aria-label={ariaLabel || label}
                        />
                    </VisuallyHiddenWrapper>
                    {checked ? (
                        <Icon
                            fileName={checkedIconFileName}
                            aria-hidden="true"
                            {...theme.CheckboxChecked}
                        />
                    ) : (
                        <Icon
                            fileName={uncheckedIconFileName}
                            aria-hidden="true"
                            {...theme.CheckboxUnchecked}
                        />
                    )}
                    {label && showLabel && <Translate>{label}</Translate>}
                    {children}
                </Label>
            </CheckboxWrapper>
        );
    }
}

export default withTheme(Checkbox);



// WEBPACK FOOTER //
// ./src/Components/Checkbox.tsx